<section>
    <div class="dashboard_bred_crumb">
        <ul>
            <li><a [routerLink]="['/profile/course-listing']" routerLinkActive="active-link">Course Listing</a></li>
            <li><img src="../../../../../assets/images/icons/bred_crumb_arrow.svg" alt=""></li>
            <li><a routerLinkActive="active-link">Registered-Users</a></li>
        </ul>
    </div>
</section>



<section class="master_add_sec" *ngIf="selectedCourse">
    <mat-card class="job-card" fxLayout="column" fxLayoutGap="16px">


        <!-- Row: Avatar + Content -->
        <div fxLayout="row" fxLayoutGap="16px" fxLayoutAlign="start">
            <!-- Avatar -->
        

            <div class="presenters" *ngIf="selectedCourse?.presenters?.length > 0; else noPresenters">
                                <swiper [config]="prsentersConfig" class="mySwiper">
                                    <div *ngFor="let presenter of selectedCourse.presenters" class="swiper-slide presenter-card">
                                        <div class="avatar">
                                            <img *ngIf="presenter?.presented_by_image?.url" [src]="presenter.presented_by_image.url"
                                                alt="Avatar" loading="lazy" />
                                        </div>
                                        <div class="presenter-name">
                                            {{ presenter.presented_by_name }}
                                        </div>
                                    </div>
                                </swiper>
                            </div>

            <ng-template #noPresenters>
                <div class="avatar"></div>
            </ng-template>

            <div fxFlex class="content-box" fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="5px">
                <!-- Top Row -->
                <div fxLayout="row" fxLayoutAlign="space-between center" class="top-row">
                    <div class="title" *ngIf="selectedCourse.course_name || selectedCourse.created_at">
                        <strong class="title_head" *ngIf="selectedCourse.course_name">
                            {{ selectedCourse.course_name }}
                        </strong>
                    </div>
                    <div>
                        <span class="date" *ngIf="selectedCourse.created_at">
                            Posted on : {{ selectedCourse.created_at | date:'dd-MM-yyyy' }}
                        </span>
                    </div>
                </div>

                <!-- <div *ngIf="selectedCourse?.presenters?.length > 0" class="company-name">
                    <ng-container *ngFor="let presenter of selectedCourse.presenters; let i = index">
                        {{ presenter.presented_by_name }} <span *ngIf="i < selectedCourse.presenters.length - 1">, </span>
                    </ng-container>
                </div> -->

                <!-- Chips + Applicants -->
                <div fxLayout="row" fxLayoutAlign="space-between center" class="chip-row">
                    <mat-chip-list class="chip-list" aria-label="Job Types" *ngIf="selectedCourse.type">
                        <mat-chip>{{ selectedCourse.type }}</mat-chip>
                    </mat-chip-list>
                </div>
            </div>
        </div>

        <div class="inner-divider"></div>
    </mat-card>

          <form class="form-section">
      <div class="filterJoblist aligned-container">
        <div class="job-status-tabs">
          <button type="button" class="status-tab" [class.active]="selectedStatus === 'ALL'"
            (click)="selectStatus('ALL')">
            All <span class="count-badge">{{ RegisterUserTabCounts?.ALL || 0 }}</span>
          </button>

          <button type="button" class="status-tab" [class.active]="selectedStatus === 'PENDING'"
            (click)="selectStatus('PENDING')">
            Pending <span class="count-badge">{{ RegisterUserTabCounts?.PENDING || 0 }}</span>
          </button>

          <button *ngIf="selectedCourse.type ==='Webinar'" type="button" class="status-tab" [class.active]="selectedStatus === 'APPROVED'"
            (click)="selectStatus('APPROVED')">
            Approved <span class="count-badge">{{ RegisterUserTabCounts?.APPROVED || 0 }}</span>
          </button>

          <button type="button" class="status-tab" [class.active]="selectedStatus === 'COMPLETED'"
            (click)="selectStatus('COMPLETED')">
            Completed <span class="count-badge">{{ RegisterUserTabCounts?.COMPLETED || 0 }}</span>
          </button>

          <button type="button" class="status-tab" [class.active]="selectedStatus === 'CANCELLED'"
            (click)="selectStatus('CANCELLED')">
            Cancelled <span class="count-badge">{{ RegisterUserTabCounts?.CANCELLED || 0 }}</span>
          </button>
        </div>

      </div>
    </form>



    <!-- register - users -->
    <div infiniteScroll [infiniteScrollDistance]="2" [infiniteScrollThrottle]="200" [scrollWindow]="true"
        (scrolled)="onScroll()">

        <div class="applicants-container">

            <!-- Loader when no users (initial) -->
            <div *ngIf="loading && registeredUsers.length === 0" class="loading-spinner" fxLayout="row"
                fxLayoutAlign="center center">
                <img src="../../../../../assets/images2/loader.gif" alt="Loading..." loading="lazy" width="120px" />
            </div>

            <!-- User cards (no wrapper div) -->
            <div *ngIf="registeredUsers.length > 0; else noUsers"> 

                <div class="applicant-card" *ngFor="let user of registeredUsers">

                    <div fxLayout="row" fxLayoutGap="16px" fxLayoutAlign="start">

                        <div class="avatar">
                            <img *ngIf="user?.directories_supplier?.dental_supplier"
                                src="{{user?.directories_supplier?.dental_supplier?.logo?.url}}" loading="lazy" />

                            <img *ngIf="user?.directories_practice?.dental_practice"
                                src="{{user?.directories_practice?.dental_practice?.logo?.url}}" loading="lazy" />

                            <img *ngIf="user?.directories_professional?.dental_professional"
                                src="{{user?.directories_professional?.dental_professional?.profile_image?.url}}"
                                loading="lazy" />

                            <img *ngIf="!user?.directories_supplier?.dental_supplier && !user?.directories_practice?.dental_practice && !user?.directories_professional?.dental_professional"
                                src="../../../../../assets/images/logo.svg" />

                        </div>

                        <div fxFlex class="content-box" fxLayout="column" fxLayoutAlign="start stretch"
                            fxLayoutGap="8px">
                            <!-- Name -->
                            <div class="applicant-name" *ngIf="user.first_name || user.last_name">
                                {{ user.first_name }} {{ user.last_name }}
                            </div>

                            <!-- Email -->
                            <div class="applicant-info" *ngIf="user.email">
                                <mat-icon class="info-icon">email</mat-icon>
                                <span class="info-text">{{ user.email }}</span>
                            </div>

                            <!-- Phone -->
                            <div class="applicant-info" *ngIf="user.phone_number">
                                <mat-icon class="info-icon">phone</mat-icon>
                                <span class="info-text">{{ user.phone_number }}</span>
                            </div>

                            <!-- Description / Job -->
                            <div class="applicant-description" *ngIf="user.description">
                                <h4 class="applicant-description-title">Description</h4>
                                {{ user.description }}
                            </div>

                            <ng-cotainer *ngIf="selectedCourse?.afterwards_price != null && selectedCourse.afterwards_price > 0 && selectedCourse?.type === 'Webinar' "> 

                                <mat-chip-list class="chip-list"  *ngIf="user?.status !== 'CANCELLED' ">
                                    <mat-chip style="color: #e19200 !important;background: #ec99001a !important;" *ngIf="user?.webinar_status === 'PENDING' "> PENDING </mat-chip>
                                    <mat-chip style="color: #d71313 !important;background: #d713131a !important;" *ngIf="user?.webinar_status === 'REJECTED' "> REJECTED </mat-chip>
                                    <mat-chip style="color: #00934f !important; background: #00934f1a !important;" *ngIf="user?.webinar_status === 'APPROVED' ">  APPROVED </mat-chip>
                                </mat-chip-list>

                            </ng-cotainer>

                            <mat-chip-list class="chip-list" >
                                    <!-- <mat-chip style="color: #e19200 !important;background: #ec99001a !important;" *ngIf="user?.status === 'PENDING' "> Status PENDING </mat-chip> -->
                                    <mat-chip style="color: #d71313 !important;background: #d713131a !important;" *ngIf="user?.status === 'CANCELLED' "> CANCELLED </mat-chip>
                                    <mat-chip style="color: #00934f !important;background: #00934f1a !important;" *ngIf="user?.status === 'COMPLETED' "> COMPLETED </mat-chip>
                                </mat-chip-list>
                           

                        </div>




                    </div>


                    <div >
                    
                        <ng-container *ngIf="loginDetails.id === selectedCourse?.created_by_id ">
                        <button *ngIf="selectedCourse?.status !== 'EXPIRED' && user?.status !== 'CANCELLED' && user?.webinar_status !== 'APPROVED' "   mat-icon-button [matMenuTriggerFor]="menu1" (click)="$event.stopPropagation()">
                            <mat-icon>more_horiz</mat-icon>
                        </button>
                        <button *ngIf="selectedCourse?.status === 'EXPIRED' && user?.status !== 'COMPLETED' && user?.status !== 'CANCELLED'  "   mat-icon-button [matMenuTriggerFor]="menu2" (click)="$event.stopPropagation()">
                            <mat-icon>more_horiz</mat-icon>
                        </button>
                        </ng-container>
                        <mat-menu #menu1="matMenu" class="table-action-btn">

                        <ng-container
                            *ngIf="selectedCourse?.afterwards_price != null && selectedCourse.afterwards_price > 0 &&  selectedCourse?.type === 'Webinar'">
                            <button *ngIf="user?.webinar_status !== 'APPROVED' " type="button" class="view" mat-menu-item
                                (click)="$event.stopPropagation(); updateStatus(user?.id,'APPROVED',undefined )">
                                <span>Approve</span>
                            </button>

                        </ng-container>

                         <button *ngIf="user?.status !== 'CANCELLED' " type="button" class="view" mat-menu-item
                                (click)="$event.stopPropagation(); updateStatus(user?.id,undefined,'CANCELLED' )">
                                <span>Cancel</span>
                        </button>   

                        </mat-menu>

                         <mat-menu #menu2="matMenu" class="table-action-btn">

                            <button  type="button" class="view" mat-menu-item
                                (click)="$event.stopPropagation(); updateStatus(user?.id,undefined,'COMPLETED' )">
                                <span>Issue Certificate</span>
                        </button>

                         </mat-menu>
                    
                    </div>


                </div>

            </div>

            <!-- Loader for infinite scroll (bottom) -->
            <div *ngIf="loading && registeredUsers.length > 0" class="loading-more" fxLayout="row"
                fxLayoutAlign="center center">
                <img src="../../../../../assets/images2/loader.gif" alt="Loading more..." loading="lazy" width="80px" />
            </div>

            <div *ngIf="allLoaded && !loading && registeredUsers.length > 0" class="no-data"
            style="padding-bottom: 20px;">
           You've reached the end — no more registered users to display
        </div>

        </div>

        <!-- No users message -->

        <div *ngIf="!loading && registeredUsers.length === 0" class="no-data-wrapper">
            <img src="../../../../../assets/images/icons/no_tasks.svg" alt="No records illustration" class="no-data-image" />
        
            <div class="no-record-text">
                No registered users available at the moment
            </div>
        </div>

        <!-- 
<ng-template #noUsers>
            <div style="text-align: center;">
                <h4 class="no_state_heading"> No registered users found.</h4>
            </div>
        </ng-template>  -->
    </div>







</section>